import { Dispatch } from 'redux';

import { IAditamento } from 'common/genericTypes';
import { typedAction } from 'store/modules/base';
import {
  GETAditamentoById,
  GETAditamentoDocument,
  GETAditamentoList,
  GETGUIDInstrumentoFinanceiro,
  PUTAditamentoApprove,
  PUTAditamentoDisapprove,
} from 'requests/aditamento';

export interface AditamentoApiResponse {
  result: IAditamento[];
  page: number;
  pageSize: number;
  totalCount: number;
}

export interface AditamentoApiState {
  getAditamentoList(
    dispatch: Dispatch,
    pagination: { page: number; pageSize: number },
    stackRequest?: boolean
  ): Promise<AditamentoApiResponse>;
  getAditamentoById(
    dispatch: Dispatch,
    instrumentoFinanceiroId: string,
    pagination: { page: number; pageSize: number },
    stackRequest?: boolean
  ): Promise<AditamentoApiResponse>;
  putAditamentoDisapprove(
    dispatch: Dispatch,
    aditamentoId: string,
    justification: string,
    stackRequest?: boolean
  ): Promise<string>;
  putAditamentoApprove(
    dispatch: Dispatch,
    aditamentoId: string,
    justification: string,
    stackRequest?: boolean
  ): Promise<string>;
  getAditamentoDocument(dispatch: Dispatch, aditamentoDocumentId: string, stackRequest?: boolean): Promise<string>;
  getGUIDInstrumentoFinanceiro(
    dispatch: Dispatch,
    instrumentoFinanceiroId: string,
    stackRequest?: boolean
  ): Promise<string>;
}

export const AditamentoApiInicialState: AditamentoApiState = {
  getAditamentoList: GETAditamentoList,
  getAditamentoById: GETAditamentoById,
  putAditamentoDisapprove: PUTAditamentoDisapprove,
  putAditamentoApprove: PUTAditamentoApprove,
  getAditamentoDocument: GETAditamentoDocument,
  getGUIDInstrumentoFinanceiro: GETGUIDInstrumentoFinanceiro,
};

enum AditamentoApiActionType {
  Update = 'aditamentosApi/UPDATE',
  Reset = 'aditamentosApi/RESET',
}

export const updateAditamentoApi = (state: AditamentoApiState) => {
  return typedAction(AditamentoApiActionType.Update, state);
};

export const resetAditamentoApi = () => {
  return typedAction(AditamentoApiActionType.Reset);
};

type AditamentoApiAction = ReturnType<typeof updateAditamentoApi | typeof resetAditamentoApi>;

export function aditamentoApiReducer(
  state: AditamentoApiState = AditamentoApiInicialState,
  action: AditamentoApiAction
): AditamentoApiState {
  switch (action.type) {
    case AditamentoApiActionType.Update:
      return { ...action.payload };
    case AditamentoApiActionType.Reset:
      return { ...AditamentoApiInicialState };
    default:
      return state;
  }
}
